"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeplinStyleguideBaseURL = exports.defaultLogoUrl = void 0;
exports.defaultLogoUrl = 'https://instabox.io/';
exports.zeplinStyleguideBaseURL = 'https://app.zeplin.io/styleguide/5e37f686e3c3402d76319c03';
